import ChooseProfileOrCreateNewModal from 'components/Modal/ChooseProfileOrCreateNewModal'
import { useBorderListContext } from 'contexts/BorderListContext'
import { useLocation, useNavigate } from 'react-router-dom'
import useClickOutside from 'hooks/useClickOutside'
import { useRef, useState } from 'react'
import './_index.scss'

const BottomBar = () => {
  const location = useLocation()
  const { data } = useBorderListContext()
  const [isChooseProfileModal, showChooseProfileModal] = useState(false)
  const [isDropdownVisible, setDropdownVisible] = useState<boolean>(false)
  const wrapperRef = useRef<HTMLDivElement>(null)

  const navigate = useNavigate()
  useClickOutside(wrapperRef, () => {
    setDropdownVisible(false)
  })

  return (
    <>
      {isChooseProfileModal && <ChooseProfileOrCreateNewModal
        body={getEmptyProfiles(data?.myBoards)}
        onClose={() => {
          showChooseProfileModal(false)
        }}
      />}

      <div className='bottomBar'>
        <div className="bottomBar__content">
          <div className={`bottomBar__btn ${location.pathname === '/' ? 'active' : undefined}`} onClick={() => navigate('/')} >
            <i className="icon icon--home"></i>
            <span>Pulpit</span>
          </div>
          <div
            className="bottomBar__btn center"
            onClick={() => {
              if (checkThereIsEmptyProfiles(data?.myBoards)) {
                showChooseProfileModal(true)
              } else {
                navigate('/addprofile')
              }
            }}>
            <div className="iconWrap">
              <i className="icon icon--add s40"></i>
            </div>
          </div>
          <div className={`bottomBar__btn ${location.pathname === '/map' ? 'active' : undefined}`} onClick={() => navigate('/map')}>
            <i className="icon icon--navigate"></i>
            <span>Mapa</span>
          </div>
          {isDropdownVisible && <div className="bottomBar__dropdown" ref={wrapperRef}>
            <div className="item" onClick={() => navigate('/addprofile')}><i className="icon icon--tabliczka"></i>Utwórz profil</div>
            <div className="item border" onClick={() => navigate('/addobituary')}><i className="icon icon--church"></i>Utwórz nekrolog</div>
            <div className="arrow"></div>
          </div>}
        </div>
      </div>
    </>
  )
}

const checkThereIsEmptyProfiles = (list?: board.BoardsList) => {
  if (!list) return false
  for (const key in list) {
    if (list[key].some(l => l.is_empty)) return true
  }
  return false
}

const getEmptyProfiles = (list?: board.BoardsList) => {
  const profiles: board.Board[] = []
  if (list) {
    for (const key in list) {
      const emptyProfiles = list[key].filter(l => l.is_empty)
      profiles.push(...emptyProfiles)
    }
  }
  return profiles
}

export default BottomBar
